import { render, staticRenderFns } from "./UserDailyInvestmentIncome.vue?vue&type=template&id=1f230029&scoped=true"
import script from "./UserDailyInvestmentIncome.vue?vue&type=script&lang=js"
export * from "./UserDailyInvestmentIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f230029",
  null
  
)

export default component.exports